//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions, mapGetters } from 'vuex'
import store from '../../common/mixins/store'
import redirectWeb from '../../common/mixins/redirectWeb'

export default {
  name: 'Stores',
  mixins: [store, redirectWeb],
  head () {
    return {
      title: this.$getPageTitle('Stores')
    }
  },
  computed: {
    ...mapGetters(['stores'])
  },
  async beforeCreate () {
    await this.$store.dispatch('getStores')
  },
  mounted () {
    this.$bvModal.hide('store-modal')
  },
  methods: {
    ...mapActions(['getStores'])
  }
}
